import React, { useMemo } from "react";
import {
  Bar,
  BarChart,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { formatWithoutDecimal } from "../../utils/formatWithoutDecimal";

const yearlySalesData = [
  { month: "Apr", value: 0 },
  { month: "May", value: 0 },
  { month: "June", value: 0 },
  { month: "July", value: 0 },
  { month: "Aug", value: 0 },
  { month: "Sept", value: 0 },
  { month: "Oct", value: 0 },
  { month: "Nov", value: 0 },
  { month: "Dec", value: 0 },
  { month: "Jan", value: 0 },
  { month: "Feb", value: 0 },
  { month: "Mar", value: 0 },
];

const monthAliasMap = {
  jan: "Jan",
  feb: "Feb",
  mar: "Mar",
  apr: "Apr",
  may: "May",
  jun: "June",
  jul: "July",
  aug: "Aug",
  sep: "Sept",
  oct: "Oct",
  nov: "Nov",
  dec: "Dec",
};

const SalesOverview = ({ className = "", visitorsData }) => {
  const currentMonth = useMemo(() => {
    const monthKey = new Date()
      .toLocaleString("en-US", { month: "short" })
      .toLowerCase();
    return monthAliasMap[monthKey] || "Apr";
  }, []);

  const monthwise = Array.isArray(visitorsData?.monthwise_current_financial_year)
    ? visitorsData.monthwise_current_financial_year
    : [];
  const apiChartData = monthwise.map((item) => ({
    month: monthAliasMap[
      new Date(2026, Number(item?.calendar_month || 1) - 1, 1)
        .toLocaleString("en-US", { month: "short" })
        .toLowerCase()
    ] || "Apr",
    value: Number(item?.total_visitors ?? 0),
  }));
  const baseData = apiChartData.length > 0 ? apiChartData : yearlySalesData;

  const chartData = useMemo(
    () =>
      baseData.map((item) => ({
        ...item,
        highlight: item.month === currentMonth,
      })),
    [baseData, currentMonth],
  );

  return (
    <div className={`col-lg-3 col-md-5 col-12 ${className}`.trim()}>
      <div
        className="card shadow-none border-0"
        style={{
          minHeight: "270px",
          borderRadius: "18px",
          background: "#FFFFFF",
          border: "1px solid #E2E8F0",
        }}
      >
        <div className="card-body px-4 pt-4 pb-3">
          <h5
            className="mb-0"
            style={{ color: "#0F172A", fontSize: "1.05rem", fontWeight: 700 }}
          >
            No of Visitors
          </h5>

          <div style={{ height: 125, marginTop: 8, marginLeft: -6 }}>
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                data={chartData}
                margin={{ top: 6, right: 0, left: 0, bottom: 0 }}
              >
                <XAxis
                  dataKey="month"
                  tick={{ fill: "#94A3B8", fontSize: 12 }}
                  axisLine={false}
                  tickLine={false}
                />
                <YAxis hide domain={[0, 55]} />
                <Tooltip
                  contentStyle={{
                    borderRadius: "10px",
                    border: "1px solid #E2E8F0",
                    boxShadow: "0 8px 20px rgba(15, 23, 42, 0.08)",
                  }}
                  formatter={(value) => [
                    formatWithoutDecimal(value),
                    "Visitors",
                  ]}
                />
                <Bar
                  dataKey="value"
                  radius={[5, 5, 0, 0]}
                  barSize={22}
                  isAnimationActive
                  animationDuration={700}
                >
                  {chartData.map((entry, index) => (
                    <Cell
                      key={`bar-${index}`}
                      fill={entry.highlight ? "#5B5CEB" : "#CDCDF0"}
                    />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>

          <div className="d-flex align-items-center justify-content-between mt-3">
            <div className="d-flex align-items-center">
              <div>
                <p
                  className="mb-0"
                  style={{ color: "#64748B", fontSize: "0.75rem" }}
                >
                  This month
                </p>
                <h6
                  className="mb-0"
                  style={{ color: "#0F172A", fontWeight: 700 }}
                >
                  {formatWithoutDecimal(visitorsData?.this_month ?? 0)}
                </h6>
              </div>
            </div>
            <div className="d-flex align-items-center">
              <div>
                <p
                  className="mb-0"
                  style={{ color: "#64748B", fontSize: "0.75rem" }}
                >
                  Last month
                </p>
                <h6
                  className="mb-0"
                  style={{ color: "#0F172A", fontWeight: 700 }}
                >
                  {formatWithoutDecimal(visitorsData?.last_month ?? 0)}
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesOverview;
